var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-group',{staticClass:"radio-control",attrs:{"label":_vm.$t(_vm.label)}},[_c('b-form-radio-group',{attrs:{"stacked":"","options":_vm.selectOptions,"checked":_vm.value},on:{"change":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }